import { createContext } from 'react'
import type { LocalizedStringLanguageContextData } from './LocalizedStringLanguageContext'

export const InternalLocalizedStringContext = createContext<LocalizedStringLanguageContextData | null>(null)
InternalLocalizedStringContext.displayName = 'LocalizedStringContext'
